import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

function preserveSearch(pathname, search) {
  return `${pathname}${search || ""}`;
}

export function EmployerLegacyManageRedirect() {
  const location = useLocation();
  return <Navigate to={preserveSearch("/dashboard/employer/jobs", location.search)} replace />;
}

export function EmployerLegacyCandidatesRedirect() {
  const location = useLocation();
  return <Navigate to={preserveSearch("/dashboard/employer/candidates", location.search)} replace />;
}

export function EmployerLegacyCreateRedirect() {
  const location = useLocation();
  return <Navigate to={preserveSearch("/dashboard/employer/jobs/wizard", location.search)} replace />;
}

export function EmployerLegacyEditRedirect() {
  const location = useLocation();
  const { id } = useParams();
  const search = new URLSearchParams(location.search);
  if (id) search.set("id", id);
  return <Navigate to={`/dashboard/employer/jobs/wizard?${search.toString()}`} replace />;
}

export function EmployerLegacyPreviewRedirect() {
  const { id } = useParams();
  return <Navigate to={`/dashboard/employer/jobs/wizard?id=${encodeURIComponent(id || "")}&step=4`} replace />;
}

export function EmployerLegacyAuthoringRedirect() {
  const { id, adv_id: legacyId } = useParams();
  const resolvedId = id || legacyId || "";
  return <Navigate to={`/dashboard/employer/jobs/wizard?id=${encodeURIComponent(resolvedId)}`} replace />;
}
